import React from 'react';

type TimelineStep = {
  label: string;
  date?: string;
  active: boolean;
  description?: string;
};

export default function DocumentTimeline({ steps }: { steps: TimelineStep[] }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 0, padding: '4px 0' }}>
      {steps.map((step, i) => (
        <div key={i} style={{ display: 'flex', gap: 12, minHeight: 40 }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 20, flexShrink: 0 }}>
            <div style={{
              width: 16, height: 16, borderRadius: '50%',
              background: step.active ? '#4f46e5' : '#e2e8f0',
              border: step.active ? '3px solid #e0e7ff' : '2px solid #e2e8f0',
              flexShrink: 0, transition: 'all .2s',
            }} />
            {i < steps.length - 1 && <div style={{
              width: 2, flex: 1,
              background: step.active ? '#4f46e5' : '#e2e8f0',
              minHeight: 20, transition: 'all .2s',
            }} />}
          </div>
          <div style={{ paddingBottom: i < steps.length - 1 ? 16 : 0 }}>
            <div style={{ fontWeight: step.active ? 700 : 500, fontSize: '.82rem', color: step.active ? '#0f172a' : '#94a3b8', transition: 'color .2s' }}>
              {step.label}
            </div>
            {step.date && <div style={{ fontSize: '.72rem', color: '#64748b', marginTop: 2 }}>{step.date}</div>}
            {step.description && <div style={{ fontSize: '.75rem', color: '#64748b', marginTop: 2 }}>{step.description}</div>}
          </div>
        </div>
      ))}
    </div>
  );
}
